import React from 'react';
import { flushSync } from 'react-dom';
import ModelInstanceSelector from '../dashboards/components/ModelInstanceSelector';
import subsidiaryCompanyService from '../services/subsidiary_company.service';
export const SubsidiaryCompanySelector = _ref => {
  let {
    companyId,
    className = '',
    alreadySelectedInstances = [],
    onChange,
    onBlur,
    onSelectInstance,
    eventFieldName,
    searchInputRef
  } = _ref;
  const [,, fetchSubsidiaryCompanies] = subsidiaryCompanyService.useFetchAll({
    companyId,
    fetchImmediately: false
  });
  const fetchSubsidiaryCompaniesByName = async subsidiaryCompanyName => {
    const allSubsidiaryCompanies = await fetchSubsidiaryCompanies();
    const filteredSubsidiaryCompanies = allSubsidiaryCompanies.filter(subsidiaryCompany => subsidiaryCompany.name?.toLowerCase().includes(subsidiaryCompanyName?.toLowerCase()));
    return {
      values: filteredSubsidiaryCompanies
    };
  };
  const buildEventLikeObject = value => {
    return {
      target: {
        type: 'select',
        value,
        name: eventFieldName
      },
      preventDefault: () => {},
      stopPropagation: () => {},
      stopImmediatePropagation: () => {}
    };
  };
  return /*#__PURE__*/React.createElement(ModelInstanceSelector, {
    className: className,
    allowMultipleSelection: false,
    selectInstances: async subsidiaryCompany => {
      const event = buildEventLikeObject(subsidiaryCompany.id);
      flushSync(() => {
        onChange(event);
      });
      onBlur(event);
      onSelectInstance && onSelectInstance(subsidiaryCompany);
    },
    onSearch: fetchSubsidiaryCompaniesByName,
    alreadySelectedInstances: alreadySelectedInstances,
    displayTextKey: 'name',
    searchInputRef: searchInputRef
  });
};
export default SubsidiaryCompanySelector;